import React from 'react'
import './styles.css'
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
function BackToTop() {
let mybutton = document.getElementById("myBtn");
window.onscroll = ()=>{scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
    mybutton.style.display = "flex";
  } else {
    mybutton.style.display = "none";
  }
}

function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
  return (
    <div className='back-to-top' id='myBtn' onClick={()=>{topFunction()}}><ArrowUpwardRoundedIcon/></div>
  )
}

export default BackToTop